import { useMemo } from 'react';
import { getTimeAxisConfig, TimeAxisConfig } from '@/utils/formatters';
import { useIsMobile } from './useIsMobile';

/**
 * Hook that returns range-aware X-axis configuration for chart components.
 *
 * Encapsulates the date range → tick/formatter logic so chart components
 * don't need to know about tick generation details.
 */
export function useTimeAxis(startDate: Date, endDate: Date): TimeAxisConfig {
  const isMobile = useIsMobile();

  return useMemo(() => {
    return getTimeAxisConfig(startDate, endDate, isMobile ? 5 : 8);
  }, [startDate, endDate, isMobile]);
}
